module.exports = __webpack_public_path__ + "images/kaitori_bonus_cp_lp/6th/campaign_banner_sp_c4bdcde145dcf4c61068183216ee2ca4.jpg";